/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik'
import { useNavigate, useParams } from 'react-router-dom';
import {
    Container, Stack, TextField, ButtonGroup, Grid,
    MenuItem, Typography, Card, IconButton, Tooltip
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../../Page';
import { ToastContainer, toast } from 'react-toastify';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import services from '../../Service';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AlertDialog } from './../../../Common/AlertDialog';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

export function Scholarship({ handleNext, handleBack, farmerId }) {
    const [message, setMessage] = useState("Delete Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [farmerScholarshipDetailID, setFarmerScholarshipDetailID] = useState();
    const [loanTypes, setLoanTypeList] = useState([]);
    const [bankList, setBankList] = useState([]);
    const [dataGrid, setDataGrid] = useState([]);

    const [factoryType, setFactoryType] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = React.useState(null);
    const [formData, setFormData] = useState({
        farmerID: 0,
        noOfChildren: '',
        farmerFamilyDetailID: '0',
        scholarshipCategoryID: 0,
        other: '',
        sarubimaStatus: 0
    });
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        Edit: false,
        submitButtonName: "Add",
        pageheadername: "Add Scholarship Details "
    });
    const ProductSaveSchema = Yup.object().shape({
        noOfChildren: dataGrid.length > 0 ? Yup.string()
            .matches(/^[1-9][0-9]?$|^100$/, 'Number of Children must be a number')
            .required('Number of Children required') : Yup.string().nullable(true),
        farmerFamilyDetailID: Yup.number().min(1, 'Please Select Sarubima Holder Name').required('Sarubima Holder Name Required'),
        other: Yup.string()
            .when('scholarshipCategoryID', {
                is: (scholarshipCategoryID) => scholarshipCategoryID == 5,
                then: Yup.string()
                    .required('Other Sarubima Category Type is Required')
                    .matches(/[a-zA-Z]/, 'Other field must contain at least one letter')
                    .test('no-leading-trailing-spaces', 'No leading or trailing spaces allowed', (value) => {
                        if (value && value.startsWith(' ')) {
                            return false;
                        }
                        return true;
                    }),
                otherwise: Yup.string().nullable(),
            }),
    });

    const formik = useFormik({
        initialValues: {
            farmerID: farmerId,
            farmerFamilyDetailID: formData.farmerFamilyDetailID,
            scholarshipCategoryID: formData.scholarshipCategoryID,
            other: formData.other,
            sarubimaStatus: formData.sarubimaStatus,
            noOfChildren: formData.noOfChildren
        },

        validationSchema: ProductSaveSchema,
        onSubmit: (values) => {
            addGrid(values)
        },
        enableReinitialize: true

    });
    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(GetFarmerFamilyDetailsbyFarmerID(farmerId));
        trackPromise(getBankForDropdown());
        trackPromise(GetFarmerScholarshipDetailsbyFarmerID(farmerId));
    }, []);

    async function GetFarmerScholarshipDetailsbyFarmerID(farmerId) {
        const res = await services.GetFarmerScholarshipDetailsbyFarmerID(farmerId);
        setDataGrid(res)
        setValues({
            ...values,
            noOfChildren: res.length == 0 ? '' : res[0].noOfChildren,
            farmerFamilyDetailID: '0',
            scholarshipCategoryID: 0,
            other: '',
            sarubimaStatus: 0
        });
    }

    async function GetFarmerFamilyDetailsbyFarmerID() {
        const loanType = await services.GetFarmerFamilyDetailsbyFarmerID(farmerId);
        if (loanType != null) {
            setLoanTypeList(loanType);
        }
    }

    async function getBankForDropdown() {
        const bank = await services.GetBanksForDropdown();
        if (bank != null) {
            setBankList(bank);
        }
        setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))
    }

    async function addGrid(values) {
        if (pageProps.Edit != true) {
            var sar = dataGrid.find(x => x.scholarshipHolderID == values.farmerFamilyDetailID
                && (values.scholarshipCategoryID == 5 ? x.other == values.other : x.scholarshipCategoryID == values.scholarshipCategoryID));
            if (sar == undefined) {
                var modelOne = {
                    farmerID: parseInt(values.farmerID),
                    noOfChildren: dataGrid.length > 0 ? parseInt(values.noOfChildren) : parseInt(1),
                    scholarshipCategoryID: parseInt(values.scholarshipCategoryID),
                    scholarshipHolder: parseFloat(values.farmerFamilyDetailID),
                    yearOfEntitled: value == null ? null : new Date(value).getFullYear() + '-' + '01' + '-' + '01',
                    createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                    other: values.scholarshipCategoryID != 5 ? "" : values.other,
                    sarubimaStatus: parseInt(0)
                }
                const res = await services.SaveFarmerScholarshipDetails(modelOne);
                if (res > 0) {
                    toast.success("Sarubima Details Saved Succesfully");
                    trackPromise(GetFarmerScholarshipDetailsbyFarmerID(farmerId));
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 2000);
                    clearAll();
                } else {
                    toast.error(res.message);
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 2000);
                }
            } else {
                toast.error("Cannot Add Same Scholarship");
                setTimeout(() => {
                    setIsLoading(false);
                }, 2000);
            }
        }
        else {
            var sar = dataGrid.find(x => x.scholarshipHolderID == values.farmerFamilyDetailID
                && (values.scholarshipCategoryID == 5 ? x.other == values.other : x.scholarshipCategoryID == values.scholarshipCategoryID));
            if (sar == undefined) {
                var modelOne = {
                    farmerID: parseInt(values.farmerID),
                    farmerScholarshipDetailID: parseInt(pageProps.editingID),
                    noOfChildren: parseInt(values.noOfChildren),
                    scholarshipCategoryID: parseInt(values.scholarshipCategoryID),
                    scholarshipHolder: parseFloat(values.farmerFamilyDetailID),
                    yearOfEntitled: value == null ? null : new Date(value).getFullYear() + '-' + '01' + '-' + '01',
                    modifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
                    other: values.other == null ? "" : values.scholarshipCategoryID != 5 ? "" : values.other,
                    sarubimaStatus: parseInt(0)
                }
                const res = await services.UpdateFarmerScholarshipDetails(modelOne);
                if (res.statusCode == 'Success') {
                    toast.success("Sarubima Details Updated Succesfully");
                    trackPromise(GetFarmerScholarshipDetailsbyFarmerID(farmerId));
                    setPageProps({
                        ...pageProps,
                        editingID: 0,
                        Edit: false,
                        submitButtonName: "Add",
                    })
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 2000);
                    clearAll();
                } else {
                    toast.error("Error occured in Farmer Sarubima Details.");
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 2000);
                }
            } else {
                toast.error("Cannot Add Same Scholarship");
                setTimeout(() => {
                    setIsLoading(false);
                }, 2000);
            }
        }
    }

    async function clearAll() {
        setValue(null);
        setValues({
            ...values,
            farmerFamilyDetailID: '0',
            scholarshipCategoryID: 0,
            other: '',
            sarubimaStatus: 0
        });
    }

    async function DeleteItem(data) {
        const res = await services.DeleteScholarshipDetails(data);
        if (res > 0) {
            toast.success("Sarubima Details Deleted Succesfully");
            trackPromise(GetFarmerScholarshipDetailsbyFarmerID(farmerId));
        } else {
            toast.error(res.message);
        }
    }

    function confirmData(y) {
        if (y) {
            DeleteItem(farmerScholarshipDetailID);
        }
    }

    function handleConfirm(data) {
        setFarmerScholarshipDetailID(data);
        setEnableConfirmMessage(true);
    }

    function handleEdit(rowData, index) {
        var array = [...dataGrid];
        setValues({
            ...values,
            farmerFamilyDetailID: rowData.scholarshipHolderID,
            scholarshipCategoryID: rowData.scholarshipCategoryID,
            other: rowData.other,
            sarubimaStatus: rowData.sarubimaStatus,
            noOfChildren: rowData.noOfChildren,
        })
        if (rowData.yearOfEntitled == null) {
            setValue(null)
        }
        else {
            setValue(new Date(rowData.yearOfEntitled + '-' + '01' + '-' + '01'))
        }
        array.splice(index, 1);
        setPageProps({
            ...pageProps,
            editingID: rowData.farmerScholarshipDetailID,
            Edit: true,
            submitButtonName: "Update",
        })
        setDataGrid(array);
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Sarubima Details |  FAPS">
                <Container>
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate onSubmit={handleSubmit}
                        >
                            <Card style={{ justifycontent: 'center' }} >
                                <Stack spacing={2} margin={3}>
                                    <Typography variant="h6">
                                        {(factoryType == 1 || factoryType == 3) ? "View Sarubima Details" : "Sarubima Details"}
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" >
                                            <ButtonGroup disableElevation variant="outlined" color="primary">
                                                <Tooltip title="Family Details">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleBack}
                                                    >
                                                        <ArrowBackIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Bank">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleNext}
                                                    >
                                                        <ArrowForwardIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </ButtonGroup>
                                        </Stack>
                                    </Typography>
                                    {(dataGrid.length > 0) ?
                                        <>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                                <Grid item xs={4} sm={4} md={4}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Number of Children *"
                                                        value={formik.values.noOfChildren}
                                                        onChange={formik.handleChange}
                                                        {...getFieldProps('noOfChildren')}
                                                        error={Boolean(touched.noOfChildren && errors.noOfChildren)}
                                                        helperText={touched.noOfChildren && errors.noOfChildren}
                                                        disabled={factoryType == 1 || factoryType == 3}
                                                        onKeyDown={(evt) =>
                                                            (evt.key === "-") && evt.preventDefault()
                                                        }
                                                        InputProps={{
                                                            inputProps: {
                                                                step: 0,
                                                                type: 'number',
                                                            },
                                                        }}
                                                        onWheel={event => event.target.blur()}
                                                    />
                                                </Grid>
                                                <Grid item xs={4} sm={4} md={4}></Grid>
                                                <Grid item xs={4} sm={4} md={4}></Grid>
                                                <Grid item xs={4} sm={4} md={4}></Grid>
                                            </Stack>
                                        </>
                                        : null}
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                        <TextField select
                                            fullWidth
                                            size="small"
                                            label="Sarubima Recipient *"
                                            value={formik.values.farmerFamilyDetailID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('farmerFamilyDetailID')}
                                            error={Boolean(touched.farmerFamilyDetailID && errors.farmerFamilyDetailID)}
                                            helperText={touched.farmerFamilyDetailID && errors.farmerFamilyDetailID}
                                            disabled={factoryType == 1 || factoryType == 3}
                                        >
                                            <MenuItem key={0} value={0}> Select Sarubima Recipient</MenuItem>
                                            {loanTypes.map((option) => (
                                                <MenuItem key={option.farmerFamilyDetailID} value={option.farmerFamilyDetailID}>
                                                    {option.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                fullWidth
                                                size="small"
                                                label="Year of receiving Sarubima "
                                                openTo="year"
                                                views={['year']}
                                                value={value}
                                                disabled={factoryType == 1 || factoryType == 3}
                                                onChange={(newValue) => {
                                                    setValue(newValue);
                                                }}
                                                minDate={'2008'}
                                                maxDate={new Date()}
                                                renderInput={(params) =>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...params}
                                                    />}
                                            />
                                        </LocalizationProvider>
                                        <TextField select
                                            fullWidth
                                            size="small"
                                            label="Sarubima Scholarship Category "
                                            value={formik.values.scholarshipCategoryID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('scholarshipCategoryID')}
                                            error={Boolean(touched.scholarshipCategoryID && errors.scholarshipCategoryID)}
                                            helperText={touched.scholarshipCategoryID && errors.scholarshipCategoryID}
                                            disabled={factoryType == 1 || factoryType == 3}
                                        >
                                            <MenuItem key={0} value={0}> Select Sarubima Scholarship Category</MenuItem>
                                            <MenuItem value={1}>Grade 5</MenuItem>
                                            <MenuItem value={2}>O/L</MenuItem>
                                            <MenuItem value={3}>University / Vocational</MenuItem>
                                            <MenuItem value={5}>Other</MenuItem>
                                        </TextField>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Other *"
                                            value={formik.values.other}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('other')}
                                            error={Boolean(touched.other && errors.other)}
                                            helperText={touched.other && errors.other}
                                            disabled={factoryType == 1 || factoryType == 3 || formik.values.scholarshipCategoryID != 5}
                                        />
                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <LoadingButton
                                            size="medium"
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                            disabled={pageProps.Edit || factoryType == 1 || factoryType == 3}
                                        >
                                            Clear
                                        </LoadingButton>
                                        <LoadingButton
                                            size="medium"
                                            type="submit"
                                            variant="outlined"
                                            color='secondary'
                                            loading={isLoading}
                                            disabled={factoryType == 1 || factoryType == 3}
                                        >
                                            {pageProps.submitButtonName}
                                        </LoadingButton>
                                    </Stack>
                                    <Divider variant="middle" />
                                    {(dataGrid.length > 0) ?
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '65rem' }} >
                                                <TableContainer component={Paper} >
                                                    <Table aria-label="caption table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Sarubima Recipient</TableCell>
                                                                <TableCell>Year of receiving Sarubima</TableCell>
                                                                <TableCell>Sarubima Category</TableCell>
                                                                {(factoryType == 1 || factoryType == 3) ? null :
                                                                    <TableCell align="center">Action</TableCell>}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {dataGrid.map((rowData, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.name}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.yearOfEntitled}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.scholarshipCategoryID == 1 ? 'Grade 5' :
                                                                            rowData.scholarshipCategoryID == 2 ? 'O/L' :
                                                                                rowData.scholarshipCategoryID == 3 ? 'University / Vocational' :
                                                                                    rowData.scholarshipCategoryID == 5 ? 'Other' : ''}
                                                                    </TableCell>
                                                                    {(factoryType == 1 || factoryType == 3) ? null :
                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {pageProps.Edit != true ?
                                                                                <Tooltip title="Edit">
                                                                                    <IconButton
                                                                                        variant="outlined"
                                                                                        onClick={() => handleEdit(rowData, index)}>
                                                                                        <EditIcon />
                                                                                    </IconButton>
                                                                                </Tooltip> : null}
                                                                            <Tooltip title="Delete">
                                                                                <IconButton
                                                                                    variant="outlined"
                                                                                    color="error"
                                                                                    onClick={(e) => handleConfirm(rowData.farmerScholarshipDetailID)}
                                                                                >
                                                                                    <DeleteIcon />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </TableCell>}
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Card>
                                        </Stack> : null}
                                </Stack>
                            </Card>
                        </Form>
                    </FormikProvider>
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want to delete scholarship details ?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
            </Page >
        </>
    )
}